import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "flex justify-center gap-6" }

import { watch } from 'vue';
import { useRoute } from 'vue-router';

import Button from 'primevue/button';
import Card from 'primevue/card';

import DefaultInput from '../components/DefaultInput.vue';

import { useAddCalculation } from '../composables/useAddCalculation';


export default /*@__PURE__*/_defineComponent({
  __name: 'NewCalculationView',
  setup(__props) {

const { name, handleAddCalculation } = useAddCalculation();

const route = useRoute();
watch(
  () => route.path,
  () => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, 50);
  },
  {
    immediate: true,
  }
);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createBlock(_unref(Card), { class: "h-max flex-1 basis-[354px] border border-gray-200 !shadow-none" }, {
    content: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("form", {
          class: "space-y-9",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(handleAddCalculation) && _unref(handleAddCalculation)(...args)), ["prevent"]))
        }, [
          _createVNode(DefaultInput, {
            placeholder: "Wpisz nazwę kalkulacji",
            modelValue: _unref(name),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null))
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode(" Nazwa kalkulacji ")
            ])),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_RouterLink, {
              to: {
                name: 'ClientView',
                params: {
                  ..._ctx.$route.params,
                },
              }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  class: "font-semibold",
                  severity: "secondary",
                  outlined: "",
                  size: "small"
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode(" Wstecz ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_unref(Button), {
              type: "submit",
              class: "font-semibold",
              size: "small",
              disabled: _unref(name).length < 4
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode(" Dodaj technologię "),
                _createElementVNode("i", { class: "pi pi-arrow-right" }, null, -1)
              ])),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 32)
      ])), [
        [_directive_auto_animate]
      ])
    ]),
    _: 1
  }))
}
}

})